/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Transcription_ErrorInputs */



/**
* | output |
* | --- |
* | "Transcription Error: {error}" |
*
* @param {Transcription_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_error = /** @type {((inputs: Transcription_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur de transcription : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Transkriptionsfehler: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore di trascrizione: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка транскрипции: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error de transcripción: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`转录错误：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`転写エラー: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रतिलेखन त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro de transcrição: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Transcription Error: ${i?.error}`)
});